import * as _ from 'lodash'
import {IBusinessObject, IBusinessObjectChanges, IBusinessObjectChangesOptions} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider, MessageType} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_MetaTagRow,
    WB_TagRelationshipRow, WB_TagRow, WB_TagTextRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbTag} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Meta,
    esWB_Meta_Tags,
    esWB_Tag, esWB_Tag_Relationship, esWB_Tag_Text
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {DefaultChanges} from "../PA.Core/BusinessObject/BusinessObjectChanges";
import {TagBOValidations} from './TagBO.Validations';

export class TagBO implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_Tag: WB_TagRow;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Tag'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_Tag = null;
    }

    get WB_Tag(): WB_TagRow {
        return this.drWB_Tag;
    }


    addRel(aWbTagId: number, sType: string): Promise<IBusinessObject> {
        var self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            // first find out if record exists.
            var found = false

            if(sType === 'Child')
                _.forEach(self.drWB_Tag.WB_TagRelationshipRows_Children, (aTagChildRelRow: WB_TagRelationshipRow) => {
                    if(aTagChildRelRow.isActive && aTagChildRelRow.cif.WB_TAG_ID == aWbTagId) {
                        found = true
                        return false
                    }
                })
            else
                _.forEach(self.drWB_Tag.WB_TagRelationshipRows_Parent, (aTagParentRelRow: WB_TagRelationshipRow) => {
                    if(aTagParentRelRow.isActive && aTagParentRelRow.cif.WB_TAG_ID_PRNT == aWbTagId) {
                        found = true
                        return false
                    }
                })

            if(found) { return } // exists..
            var aTagRelRow: WB_TagRelationshipRow = undefined

            self.dbContext.find(esWB_Tag, aWbTagId)
                .then((aRelRecord: WB_TagRelationshipRow) => {
                    if (_.isEmpty(aRelRecord)) {
                        // Bad Tag Id...
                        resolve(self)
                        return
                    }
                    aTagRelRow = aRelRecord

                    // create new records
                    return self.dbContext.createRecordWithKey(esWB_Tag_Relationship)

                })
                .then((aNewRow: WB_TagRelationshipRow) => {
                    aNewRow.setDefaults()
                    if(sType === 'Child') {
                        aTagRelRow = aNewRow
                        aTagRelRow.cif.WB_TAG_ID_PRNT = self.drWB_Tag.cif.WB_TAG_ID
                        aTagRelRow.cif.WB_TAG_ID = aWbTagId
                    }
                    else {
                        aTagRelRow = aNewRow
                        aTagRelRow.cif.WB_TAG_ID_PRNT = aWbTagId
                        aTagRelRow.cif.WB_TAG_ID = self.drWB_Tag.cif.WB_TAG_ID
                    }
                    self.dbContext.add(esWB_Tag_Relationship, aTagRelRow)
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    removeRel(aWbChildId: number, sType: string): Promise<IBusinessObject> {
        var self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            if(sType === 'Child')
                _.forEach(self.drWB_Tag.WB_TagRelationshipRows_Children, (aTagRelRow: WB_TagRelationshipRow) => {
                    if(aTagRelRow.isActive && aTagRelRow.cif.WB_TAG_ID == aWbChildId) {
                        aTagRelRow.markDeleted()
                    }
                })
            else
                _.forEach(self.drWB_Tag.WB_TagRelationshipRows_Parent, (aTagRelRow: WB_TagRelationshipRow) => {
                    if(aTagRelRow.isActive && aTagRelRow.cif.WB_TAG_ID_PRNT == aWbChildId) {
                        aTagRelRow.markDeleted()
                    }
                })

            resolve(self)
        })
    }

    addText(options? : object): Promise<IBusinessObject> {
        var self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            var aTagTextRow: WB_TagTextRow = undefined

           self.dbContext.createRecordWithKey(esWB_Tag_Text)
                .then((aNewRow: WB_TagTextRow) => {
                    aNewRow.setDefaults()
                    aTagTextRow = aNewRow
                    aTagTextRow.cif.WB_TAG_ID = self.drWB_Tag.cif.WB_TAG_ID
                    self.dbContext.add(esWB_Tag_Text, aTagTextRow)
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    removeText(aWbTextId: number, sType: string): Promise<IBusinessObject> {
        var self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            _.forEach(self.drWB_Tag.WB_TagTextRows, (aTagTextRow: WB_TagTextRow) => {
                    if(aTagTextRow.isActive && aTagTextRow.cif.WB_TAGT_ID == aWbTextId) {
                        aTagTextRow.markDeleted()
                    }
                })

            resolve(self)
        })
    }

    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        var self = this;
        this.LoadProgressProvider.start("Creating Tag");
        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, error) => {

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new Tag.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_Tag)
                .then((newTagRow: WB_TagRow)=> {
                    newTagRow.setDefaults()

                    self.drWB_Tag = newTagRow;
                    self.dbContext.add(esWB_Tag, newTagRow)
                    self.Identity.setAll(self.WB_Tag.cif.WB_TAG_ID, self.WB_Tag.cif.TAG_ID, self.WB_Tag.cif.TAG_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Tag, 'WB_TAG_ID', 'TAG_ID', 'TAG_NAME')

                  return self.drWB_Tag.loadRelations([esWB_Tag_Relationship, esWB_Tag_Text],
                        self.LoadOptions)

                }).then((r) => {
                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);

                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })

        });

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        const self = this;
        if(!this.bIsLoaded)
            this.Identity.setAll( anId, anId,'Loading Tag (' + anId + ')')

        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, reject) => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if(self.bIsLoaded) {
                var sError = "Tag already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new Tag.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            this.dbContext.find(esWB_Tag,  anId)
                .then(function (aTagRow){

                    if(_.isEmpty(aTagRow))
                    {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_Tag = aTagRow;
                    self.Identity.setAll(self.WB_Tag.cif.WB_TAG_ID, self.WB_Tag.cif.TAG_ID, self.WB_Tag.cif.TAG_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Tag, 'WB_TAG_ID', 'TAG_ID', 'TAG_NAME')

                    // TODO, add in additional child relationships.
                    return (self.drWB_Tag.loadRelations([esWB_Tag_Relationship, esWB_Tag_Text, esWB_Meta_Tags],
                             self.LoadOptions));
                })
                .then((aTagRow: WB_TagRow) => {
                    var nextTasks: Promise<any>[] = []
                    _.forEach(aTagRow.WB_TagRelationshipRows_Children, (aRow: WB_TagRelationshipRow) => {
                        nextTasks.push(aRow.loadRelations([esWB_Tag]));
                    });
                    _.forEach(aTagRow.WB_TagRelationshipRows_Parent, (aRow: WB_TagRelationshipRow) => {
                        nextTasks.push(aRow.loadRelations([esWB_Tag]));
                    });
                    _.forEach(aTagRow.WB_TagMetaRows, (aRow: WB_MetaTagRow) => {
                        nextTasks.push(aRow.loadRelations([esWB_Meta]));
                    });

                    return Promise.all(nextTasks)
                })
                .then((aTagRow:any) => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch(function(err:any){
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    reject(err);
                });

        });

        return this._OnLoadComplete;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    async Validate(options?: any): Promise<IBusinessObject> {

        const self = this

        try {
            this.ValidateMessageProvider.clearMessages()
            this.ValidateProgressProvider.start("Validating " + self.WB_Tag.cif.TAG_NAME + "(" + self.WB_Tag.cif.TAG_ID + ")")


            self.ValidateOptions = options || {}

            if (self.dbContext == undefined) {
                var sError = "Unable to determine dbContext for to Validate Circular Config."
                self.ValidateProgressProvider.exception(sError)
                throw new Error(sError)
            }

            await TagBOValidations.Validate(self)

            if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) self._bIsValidated = false
            else self._bIsValidated = true
            
            self.ValidateProgressProvider.finish()
            return self

        } catch (err) {
            self._bIsValidated = false
            self.ValidateProgressProvider.exception(err)
            return self
        }
    }


    Validates(options?: any): Promise<IBusinessObject> {

        var self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_Tag.cif.TAG_NAME + "(" + self.WB_Tag.cif.TAG_ID + ")");
        return new Promise<IBusinessObject>( (resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if(self.dbContext == null) {
                var sError = "Unable to determine dbContext for to Validate Tag.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean,  options?: any): Promise<IBusinessObject> {

        var self = this;
        var wbTag = <IwbTag>self.drWB_Tag;
        this.SaveProgressProvider.start("Saving " + wbTag.TAG_NAME + "(" + wbTag.TAG_ID + ")");

        return new Promise<IBusinessObject>( (resolve, reject) => {

            if(this.dbContext == null) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save Tag.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }

            self.SaveOptions = options || {};

            var saveFunction: (esName: string, saveRecords: ESRecord[]| ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            self.Validate({})
              .then((ignored) => {
                
                if (!self.bIsValidated) {
                    self._bIsSaved = false
                    self.SaveProgressProvider.finish()
                    resolve(self)
                    return
                } else {
                    return saveFunction(esWB_Tag, self.drWB_Tag,{})
                }
                
              })
              .then((ignored) => {
                var tasks: Promise<any>[] = []
                  tasks.push(saveFunction(esWB_Tag_Relationship, self.drWB_Tag.WB_TagRelationshipRows_Children))
                  tasks.push(saveFunction(esWB_Tag_Relationship, self.drWB_Tag.WB_TagRelationshipRows_Parent))
                  tasks.push(saveFunction(esWB_Tag_Text, self.drWB_Tag.WB_TagTextRows))

                  _.forEach(self.drWB_Tag.WB_TagRelationshipRows_Children, (aChildRow: WB_TagRelationshipRow) => {
                    tasks.push(saveFunction(esWB_Tag,aChildRow.WB_TagRowChild ))
                  })

                _.forEach(self.drWB_Tag.WB_TagRelationshipRows_Parent, (aParentRow: WB_TagRelationshipRow) => {
                  tasks.push(saveFunction(esWB_Tag,aParentRow.WB_TagRowParent ))
                })

                return Promise.all(tasks)
              })
              .then((ignored) => {
                  if (bBatch) {
                      self.dbContext.addBatchCompleteListener(()=> {
                          self._bIsSaved = true;
                      })
                  } else {
                      self._bIsSaved = true;
                  }
                  self.SaveProgressProvider.finish();
                  resolve(self);
              })
              .catch((err) => {
                  self.SaveProgressProvider.exception(err);
                  resolve(self)
              })
        });
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbTag = <IwbTag>self.drWB_Tag;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbTag.TAG_NAME + "(" + wbTag.TAG_ID + ")");
        return new Promise<IBusinessObject>( (resolve, error) => {

            // 1. Validate if we can delete the Tag

            // 2. If Valid, mark all the records for deletion.
            self.drWB_Tag.markDeleted()
            _.forEach(self.drWB_Tag.WB_TagRelationshipRows_Children,(aRow) => { if(aRow.isActive){ aRow.markDeleted()} })
            _.forEach(self.drWB_Tag.WB_TagRelationshipRows_Parent,(aRow) => { if(aRow.isActive){ aRow.markDeleted()} })

            if(bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    Changes(options?: IBusinessObjectChangesOptions): IBusinessObjectChanges {
        let opts = options || {}
        // Set any BO Specific change settings
        return DefaultChanges(this, this.drWB_Tag, opts)
    }

    //</editor-fold>

};
PAEnvironment.registerBusinessObjectClass( TagBO, "TagBO" ,"Tag")